module.exports = __webpack_public_path__ + "b8e4795afedbea6534424a6cac6d8e18.svg";